import { handleFormChange, submitCreateForm } from "@/utils/formChange"
import { FormEvent } from "react"
import { Button } from "@/components/ui/button"
import { formInterface } from "@/interface/dataInterface"
import { useRefresh } from "react-admin"
import VehicleFormCommon from "@/components/common/form/VehicleForm"

const VehicleForm = (props: formInterface) => {
    return (
        <VehicleFormCommon formProp={props.formProp} setFormProp={props.setFormProp} />
    )
}

export default VehicleForm